import { queryLocalStorage } from 'navigation-components/common/utils';
const SELENIUM_DISABLE_BANNERS_KEY = 'selenium.disable.banners';
export default (() => {
  try {
    const disabled = queryLocalStorage(SELENIUM_DISABLE_BANNERS_KEY) === 'true';
    if (disabled) {
      console.warn(`Banner notifications are currently disabled. Unset '${SELENIUM_DISABLE_BANNERS_KEY}' in localStorage to enable.`);
    }
    return disabled;
  } catch (_unused) {
    return false;
  }
});